<template>
     <div class="return-top" @click="returnTop" :class="{'show':seen}"></div>
</template>

<script>
  import "common/js/requestAnimationFrame.min"
  export default {
      name: 'v-return-top',
      data() {
        return {
          seen:false
        }
      },
      methods:{
        returnTop () {
          let scrollTop = this.scrollTop();
          if( scrollTop > 0){
            requestAnimationFrame(this.returnTop);
            scrollTo(0,scrollTop - scrollTop / 8);
          }
        },
        isShow () {
           this.seen = this.scrollTop() > 200
        }
      },
      mounted(){
        window.addEventListener('scroll',this.isShow,false);
      }
    }
</script>

<style lang="scss" scoped>
  .return-top{
    position: fixed;
    bottom: 160px;
    right: 40px;
    width: 34px;
    height: 34px;
    z-index: 1000;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s;
    background: url(../assets/return-top.jpg) no-repeat;
    @media (max-width: 768px) {
      right: 12px;
    }
    @media (max-width: 640px) {
      bottom: 90px;
    }
    &.show{
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VReturnTop.vue